export default function Vision() {
  return (
    <section className="mx-auto max-w-6xl px-4 py-5 sm:px-8 sm:py-8">
      <div className="relative overflow-hidden rounded-[24px] sm:rounded-[32px] bg-[#EEF3FF] border border-[#D5E4FF] shadow-[0_4px_24px_rgba(0,0,0,0.02)] h-[640px] md:h-[380px] flex flex-col md:block">
        {/* Desktop Background image */}
        <img
          src="/img/about-us/Our-Vision.png"
          alt="Vision"
          className="hidden md:block w-full h-full object-cover object-[75%_center] sm:object-center absolute inset-0 z-0"
        />
        {/* Mobile Background image (Determines height on mobile) */}
        <img
          src="/img/about-us/Our-Vision-mobile view.png"
          alt="Vision"
          className="block md:hidden w-full h-full absolute inset-0 object-contain z-0"
        />

        {/* Text overlay */}
        <div className="absolute inset-0 z-10 flex flex-col pt-[230px] md:pt-10 px-5 md:px-12 max-w-xl md:justify-start items-center md:items-start text-center md:text-left">

          <h2 className="text-2xl sm:text-4xl font-extrabold text-[#0A0F1E] mb-4 sm:mb-4">
            Our Vision
          </h2>
          <p className="text-sm sm:text-base text-[#374151] leading-relaxed mb-4 sm:mb-4">
            We envision a world where solo travelers can confidently explore
            new destinations, build genuine friendships, and create
            unforgettable memories without feeling alone.
          </p>
          <p className="text-sm sm:text-base text-[#374151] leading-relaxed">
            While these tools promote a safer community, we encourage every
            traveler to exercise good judgment, verify information independently,
            and follow safe travel practices when meeting new people.
          </p>
        </div>
      </div>
    </section>
  );
}